export const TESTIMONIAL_TITLE = "Testimonials";

export const UserTestimonials = [
  {
    firstName: "Roben",
    lastName: "Andrews",
    dated: "2023 Mar 10",
    comment:
      "I owe my success to this institute! The comprehensive curriculum, experienced faculty, and practical approach to commerce education shaped my skills and mindset. Truly a launching pad for a thriving career!",
  },
  {
    firstName: "Ashok",
    lastName: "Raj",
    dated: "2022 Sept 22",
    courseAttended: "GST",
    comment:
      "Exceptional! The institute's focus on real-world applications prepared me for the dynamic business landscape. The supportive community and insightful guidance empowered me to start and grow my own business.",
  },
  {
    firstName: "Mujeeb",
    lastName: "Rahman",
    dated: "2023 Mar 04",
    courseAttended: "CGP",
    comment:
      "The finance program at this institute is unparalleled. The faculty's expertise and the hands-on learning opportunities equipped me with the tools needed to excel in the competitive financial sector. Highly recommend!",
  },
  {
    firstName: "John",
    lastName: "Daniel",
    dated: "2022 Apr 20",
    courseAttended: "CAT",
    comment:
      "Top-notch accounting education! The institute's commitment to excellence, modern curriculum, and emphasis on practical skills development have been instrumental in shaping my career. Grateful for the foundation I received here!",
  },
];
